export default {
    table: (state) => state.pagination.clients,
    pagination: (state) => state.pagination.pagination,
    loading: (state) => state.pagination.loading,
    selectedTab: (state) => state.pagination.selectedTab,
    selectedType: (state) => state.pagination.selectedType
}